import React from 'react';
import { useIntl } from 'react-intl';
import { EllipsisOutlined, RightOutlined } from '@ant-design/icons';
import type { CategoryConfig, CategoryQuestionNode } from '../../../types/category';
import { isQuestionBranch } from '../../../types/categoryQuestionTree';
import CategoryIcon from './CategoryIcon';
import './questionSelect.css';

interface QuestionSelectVars {
  cardBg: string;
  text: string;
  textSecondary: string;
  border: string;
  accent: string;
  hoverBg: string;
}

interface QuestionSelectBodyProps {
  categoryConfig: CategoryConfig;
  options: CategoryQuestionNode[];
  vars: QuestionSelectVars;
  onSelect: (node: CategoryQuestionNode) => void;
  onSelectOther: () => void;
}

const QuestionSelectBody: React.FC<QuestionSelectBodyProps> = ({
  categoryConfig,
  options,
  vars,
  onSelect,
  onSelectOther,
}) => {
  const intl = useIntl();

  return (
    <div
      className="uchat-qp"
      style={
        {
          '--qp-card-bg': vars.cardBg,
          '--qp-text': vars.text,
          '--qp-text-secondary': vars.textSecondary,
          '--qp-border': vars.border,
          '--qp-accent': vars.accent,
          '--qp-hover': vars.hoverBg,
        } as React.CSSProperties
      }
    >
      <div className="uchat-qp-category">
        <CategoryIcon config={categoryConfig} size={22} />
        <span className="uchat-qp-category-name">{categoryConfig.name}</span>
      </div>
      <div className="uchat-qp-title">
        {intl.formatMessage({
          id: 'v2.select_question',
          defaultMessage: 'Please select a question',
        })}
      </div>
      <div className="uchat-qp-list">
        {options.map((node, index) => {
          const branch = isQuestionBranch(node);
          return (
            <button
              key={node.id}
              type="button"
              className="uchat-qp-item"
              style={{ animationDelay: `${index * 40}ms` }}
              onClick={() => onSelect(node)}
            >
              <span className="uchat-qp-index">{String(index + 1).padStart(2, '0')}</span>
              <span className="uchat-qp-item-title">{node.title}</span>
              {branch ? <RightOutlined className="uchat-qp-item-arrow" /> : null}
            </button>
          );
        })}
        <button
          type="button"
          className="uchat-qp-item uchat-qp-other"
          style={{ animationDelay: `${options.length * 40}ms` }}
          onClick={onSelectOther}
        >
          <span className="uchat-qp-index">
            <EllipsisOutlined />
          </span>
          <span className="uchat-qp-item-title">
            {intl.formatMessage({ id: 'v2.question_other', defaultMessage: 'Other' })}
          </span>
        </button>
      </div>
    </div>
  );
};

export default QuestionSelectBody;
